import Vuex from 'vuex';

const state = {
  isSticky: false,
  showMainNavigation: false,
  height: 0
};

const getters = {
  isSticky: (state, getters, rootState) => {
    return state.isSticky;
  },
  stickyHeight: (state, getters, rootState) => {
    return state.height;
  },
  stickyStyle: (state, getters, rootState) => {
    if(!state.isSticky) {
      return {};
    }
    return {
      'top': `${state.showMainNavigation ? 0 : '-' + state.height}px`
    };
  },
  showMainNavigation: (state, getters, rootState) => {
    return state.showMainNavigation;
  }
};

const actions = {
  setStickyHeight: ({ state, commit, rootState }) => {
    if(['lap', 'desktop'].includes(rootState.mediaqueries.currentMediaQueryName)){
        commit('setStickyHeightState', { height: 91 });
    } else {
      commit('setStickyHeightState', { height: 44 });
    }
  },
  setShowMainNavigation: ({ state, commit, rootState }, show) => {
    if(state.showMainNavigation != show) {
        commit('setShowMainNavigationState', { show });
    }
  },
  setSticky: ({ state, commit, rootState }, sticky) => {
    commit('setIsStickyState', { sticky })
  }
};

const mutations = {
  setIsStickyState: (state, { sticky }) => {
    state.isSticky = sticky;
  },
  setStickyHeightState: (state, { height }) => {
    state.height = height;
  },
  setShowMainNavigationState: (state, { show }) => {
    state.showMainNavigation = show;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./store/modules/sticky.js